import React from 'react';

import { IconButton } from 'e100-react-components';

import { useStyles } from './styles';

export const SelectCloseButton = ({ onClick }: SelectCloseButtonProps) => {
  const classes = useStyles();

  return (
    <IconButton
      kind={'close'}
      onClick={onClick}
      classes={{
        button: {
          root: classes.iconButtonRoot
        },
        icon: {
          root: classes.iconRoot
        }
      }}
    />    
  );
};

interface SelectCloseButtonProps {
  onClick?: () => void;
}